import type React from 'react';

import { Portal, Snackbar, makeStyles } from '@material-ui/core';

import { Alert as MuiAlert } from '@material-ui/lab';
import type { AlertProps, Color } from '@material-ui/lab';

const Alert: React.FC<AlertProps> = (props) => {
  return <MuiAlert elevation={6000} variant="filled" {...props} />;
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  }
}));

interface IProps {
  duration?: number;
  message: string;
  open: boolean;
  type: Color;

  onClose?: () => void;
}

const Toastify: React.FC<IProps> = ({ open, message, duration, type, onClose }: IProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Portal>
        <Snackbar
          open={open}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHide={false}
          autoHideDuration={duration}
          onClose={onClose}
        >
          <Alert className="flex items-center " severity={type}>
            {message}
          </Alert>
        </Snackbar>
      </Portal>
    </div>
  );
};

export default Toastify;
